module.exports = __webpack_public_path__ + "static/media/4 surrealism female figure color sleeve tattoo.1280x1706.a9a1d313.webp";